import React, { useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { MenuIcon } from "@heroicons/react/solid";
import { useSelector } from "react-redux";
import { Link,NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  faAddressCard,
  faCar,
  faChartPie,
  faCreditCard,
  faHome,
} from "@fortawesome/fontawesome-free-solid";
import {
  faCalendar,
  faFileCirclePlus,
  faGear,
  faGhost,
  faListCheck,
  faLocationCrosshairs,
  faUsersGear,
  faVectorSquare,
  faRightFromBracket,
  faFileLines,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../b2b/Modal";

export default function DropDown() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {token,user} = useSelector((state) => state.auth);

  const [ addLogoutModal, setaddLogoutModal ] = useState(false);
  
  return (
    <div>
      <Menu as="div" className="relative inline-block text-right">
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md text-sm font-medium text-black  focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <MenuIcon className="w-5" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
         {!token ? <Menu.Items className="absolute top-10 mt-2 w-80 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-body hover:bg-secondary`}
                  >
                    <Link to="/login">Client Login</Link>
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-body hover:bg-secondary`}
                  >
                    <Link to="/signup">Signup</Link>
                  </button>
                )}
              </Menu.Item>
            
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-body hover:bg-secondary`}
                  >
                    <Link to="/">Addon Service</Link>
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-body hover:bg-secondary`}
                  >
                    <Link to="/aboutUs">About Us</Link>
                  </button>
                )}
              </Menu.Item>
            
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-body hover:bg-secondary`}
                  >
                    <Link to="/contactUs">Contact Us</Link>
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items> : (
            
            <Menu.Items className="absolute z-10 -ml-3 mt-3 w-60 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-4 py-3 space-y-1 mt-2 text-sm">
           
            <MenuItemDropDown iconName={faHome} label="Home" routeLink="/home" />
              <MenuItemDropDown
                iconName={faFileCirclePlus}
                label="New Booking"
                routeLink="/newbooking"
              />
              {user?.role === "ADMIN" && (
                <MenuItemDropDown
                  iconName={faGhost}
                  label="Offline Booking"
                  routeLink="/offlinebooking"
                />
              )}
              <MenuItemDropDown
                iconName={faListCheck}
                label="Manage Booking"
                routeLink="/manageBooking"
              />

              {user?.role === "ADMIN" ? (
                <MenuItemDropDown
                  iconName={faAddressCard}
                  label="Affliate"
                  routeLink="/affiliate"
                />
              ) : (
                user?.role === "USER" &&
                user?.permission?.affiliate?.permission === "ENABLE" && (
                  <MenuItemDropDown
                    iconName={faAddressCard}
                    label="Affliate"
                    routeLink="/affiliate"
                  />
                )
              )}

              {user?.role === "ADMIN" ? (
                <MenuItemDropDown
                  iconName={faGear}
                  label="Settings"
                  routeLink="/settings"
                />
              ) : (
                user?.role === "USER" &&
                user?.permission?.generalSettings?.permission === "ENABLE" && (
                  <MenuItemDropDown
                    iconName={faGear}
                    label="Settings"
                    routeLink="/settings"
                  />
                )
              )}

              {user?.role === "ADMIN" ? (
                <MenuItemDropDown
                  iconName={faLocationCrosshairs}
                  label="Regions"
                  routeLink="/regions"
                />
              ) : (
                user?.role === "USER" &&
                user?.permission?.regions?.permission === "ENABLE" && (
                  <MenuItemDropDown
                    iconName={faLocationCrosshairs}
                    label="Regions"
                    routeLink="/regions"
                  />
                )
              )}

              <MenuItemDropDown
                iconName={faUsersGear}
                label="User Management"
                routeLink="/usermanagement"
              />
              {user?.role === "ADMIN" ? (
                <MenuItemDropDown
                  iconName={faCar}
                  label="Vehicle Types"
                  routeLink="/vehicletype"
                />
              ) : (
                user?.role === "ADMIN" &&
                user?.permission.vehicleTypes?.permission === "ENABLE" && (
                  <MenuItemDropDown
                    iconName={faCar}
                    label="Vehicle Types"
                    routeLink="/vehicletype"
                  />
                )
              )}

              {user?.role === "ADMIN" && (
                <MenuItemDropDown
                  iconName={faChartPie}
                  label="Statistics"
                  routeLink="/statistics"
                />
              )}
              {user?.role === "ADMIN" && (
                <MenuItemDropDown
                  iconName={faCalendar}
                  label="Event"
                  routeLink="/event"
                />
              )}
              {user?.role === "ADMIN" && (
                <MenuItemDropDown
                  iconName={faCreditCard}
                  label="Credit Card"
                  routeLink="/creditcard"
                />
              )}
              {/* {user?.role === "ADMIN" && (
                <MenuItemDropDown
                  iconName={faFileLines}
                  label="API Docs"
                  routeLink="/apidocs"
                />
              )} */}
              <div>
                  <div onClick={setaddLogoutModal} className="flex items-center px-5 p-2 space-x-6 rounded-md text-base text-gray-700 hover:bg-gray-200 cursor-pointer mb-10">
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    <h2 className="font-body">Logout</h2>
                  </div>

                  <div className="flex justify-between">
                    {addLogoutModal && (
                      <>
                        <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50">
                          <Modal
                            heading="Log Out"
                            cancelOnClick={() => {
                              setaddLogoutModal(false);
                            }}
                            addOnClick={() => {
                              dispatch({ type: "LOGOUT", payload: { navigate } });                      
                              setaddLogoutModal(false);
                            }} 
                            addButtonLabel="Logout"
                            isLoggedOut={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
              </div>
            </div>
            </Menu.Items>
            
          )}
        </Transition>
      </Menu>
    </div>
  );
}


const MenuItemDropDown = ({routeLink,iconName,label}) => {
  return (
    <Menu.Item>
    {({ active }) => (
      <NavLink
        to={routeLink}
        className={({ isActive }) =>
            isActive
            ? "group flex items-center p-2 space-x-3 rounded-md text-base active:text-white text-gray-700 font-normal active:bg-secondary cursor-pointer"
            : "flex items-center p-2 space-x-3 rounded-md text-base text-gray-700 hover:bg-gray-200 cursor-pointer"
        }
      >
      <FontAwesomeIcon icon={iconName} className="text-gray-900 w-10" />
      <div>{label}</div>      
      </NavLink>
    )}
  </Menu.Item>
  )
}